import { useNavigate } from "react-router-dom";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../../assets/Icons";
import FieldForceAccountDetails from "../../../../containers/Accounts/FieldForceAccount/FieldForceAccountDetails";

function FieldForceAccDetailPagePopup({
  closeFieldForceAccountDetailModal,
  field_force_account_id,
  type = "field_force_account_detail_modal",
  setAllAccounts,
  showCategory = false,
}) {
  const navigate = useNavigate();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle="Field force account details page"
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        isfullViewrequired={true}
        isscrollRequired={true}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closeFieldForceAccountDetailModal();
          navigate(
            `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${field_force_account_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closeFieldForceAccountDetailModal}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
      >
        <FieldForceAccountDetails
          field_force_account_id={field_force_account_id}
          closeBeneAccountDetailModal={closeFieldForceAccountDetailModal}
          type={type}
          setAllAccounts={setAllAccounts}
          showCategory={showCategory}
        />
      </LargePopupRedirect>
    </div>
  );
}

export default FieldForceAccDetailPagePopup;
